module.exports = __webpack_public_path__ + "images/5d52d970e4095e836a3f939953d40ec0.jpg";